import {
  blogErrorHandler,
  galleryErrorHandler,
  logoErrorHandler,
  photoErrorHandler,
  sectionBgErrorHandler,
  slideBgErrorHandler,
} from './ErrorHandlers';

const imageErrorHandler = () => {
  blogErrorHandler();
  photoErrorHandler();
  galleryErrorHandler();
  logoErrorHandler();
  sectionBgErrorHandler();
  slideBgErrorHandler();
};

export default imageErrorHandler;
